(function ($) {

    function initCarouselShelf(scope) {

        const $scope = $(scope);
        const $slider = $scope.find('[data-carousel-slider]');
        const $navItems = $scope.find('[data-carousel-go-to]');

        if (!$slider.length || $slider.hasClass('slick-initialized')) {
            return;
        }

        const transition =
            scope.dataset.transition || 'slide';

        const interval =
            parseInt(scope.dataset.interval, 10) || 5000;

        const autoplay =
            scope.dataset.autoplay !== 'false';


        /* =====================================================
           Slick
           ===================================================== */

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,

            fade: transition === 'fade',

            speed:
                transition === 'fade'
                    ? 600
                    : 700,

            cssEase: 'ease',

            arrows: false,
            dots: false,

            infinite: true,

            autoplay: autoplay === true,
            autoplaySpeed: interval,

            adaptiveHeight: false,

            accessibility: true,

            pauseOnHover: true,
            pauseOnFocus: true
        });


        /* =====================================================
           Navigation
           ===================================================== */

        $navItems.on('click', function () {

            const index = Number(
                $(this).attr('data-carousel-go-to')
            );

            if (Number.isNaN(index)) {
                return;
            }

            $slider.slick(
                'slickGoTo',
                index
            );

        });


        /* =====================================================
           Active navigation state
           ===================================================== */

        $slider.on(
            'afterChange',
            function (
                event,
                slick,
                currentSlide
            ) {

                $navItems
                    .removeClass('is-active')
                    .attr('aria-current', 'false');

                $navItems
                    .filter(
                        '[data-carousel-go-to="' +
                        currentSlide +
                        '"]'
                    )
                    .addClass('is-active')
                    .attr('aria-current', 'true');

            }
        );


        /* =====================================================
           Initial navigation state
           ===================================================== */

        $navItems
            .removeClass('is-active')
            .attr('aria-current', 'false');

        $navItems
            .eq(0)
            .addClass('is-active')
            .attr('aria-current', 'true');

    }


    /* =========================================================
       Logo Carousel
       ========================================================= */

    function initLogoCarousel(scope) {

        const $carousel = $(scope);

        if ($carousel.hasClass('slick-initialized')) {
            return;
        }

        const reduceMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;

        $carousel.slick({
            slidesToShow: 4,
            slidesToScroll: 1,

            infinite: true,

            autoplay: !reduceMotion,
            autoplaySpeed: 3000,

            speed: 700,
            cssEase: 'ease',

            arrows: false,
            dots: false,

            accessibility: true,

            pauseOnHover: true,
            pauseOnFocus: true,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        

    }

        /* =========================================================
       Product Carousel
       ========================================================= */

    function initProductCarousel(scope) {

        const $carousel = $(scope);

        if ($carousel.hasClass('slick-initialized')) {
            return;
        }

        const $wrapper = $carousel.closest('.product-carousel');
        const $nav = $wrapper.find('[data-product-carousel-nav]');
        const $navItems = $nav.find('[data-product-slide]');

        const reduceMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;


        /* -----------------------------------------------------
           Initialise Slick
           ----------------------------------------------------- */

        $carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            autoplay: false,
            speed: reduceMotion ? 0 : 700,
            cssEase: 'ease',
            adaptiveHeight: true,
            accessibility: true,
            swipe: true,
            draggable: true
        });


        /* -----------------------------------------------------
           Product navigation
           ----------------------------------------------------- */

        $navItems.on('click', function () {

            const index = parseInt(
                $(this).attr('data-product-slide'),
                10
            );

            if (Number.isNaN(index)) {
                return;
            }

            $carousel.slick('slickGoTo', index);
        });


        /* -----------------------------------------------------
           Keep navigation in sync
           ----------------------------------------------------- */

        $carousel.on(
            'afterChange',
            function (event, slick, currentSlide) {

                $navItems
                    .removeClass('is-active')
                    .removeAttr('aria-current');

                $navItems
                    .filter(
                        '[data-product-slide="' +
                        currentSlide +
                        '"]'
                    )
                    .addClass('is-active')
                    .attr('aria-current', 'true');
            }
        );
    }


    /* =========================================================
       Front end
       ========================================================= */

    $('.carousel-shelf').each(function () {
        initCarouselShelf(this);
    });

    $('[data-logo-carousel]').each(function () {
        initLogoCarousel(this);
    });

    $('[data-product-carousel]').each(function () {
        initProductCarousel(this);
    });

})(jQuery);